import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const GridIcon = ({ stroke, fill, active, ...props }) => {
  const useStyles = makeStyles({
    cls3: {
      fill,
      opacity: active ? 1 : 0.3,
      borderRadius:`0!important`
    },
  });
  const classes = useStyles();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"45" || props.width}
      height={"25" || props.height}
      viewBox="0 0 19.704 19.704"
      className={classes.cls3}

    >
      <path
        className={classes.cls3}
        d="M0,0V4.926H4.926V0ZM7.389,0V4.926h4.926V0Zm7.389,0V4.926H19.7V0ZM0,7.389v4.926H4.926V7.389Zm7.389,0v4.926h4.926V7.389Zm7.389,0v4.926H19.7V7.389ZM0,14.778V19.7H4.926V14.778Zm7.389,0V19.7h4.926V14.778Zm7.389,0V19.7H19.7V14.778Z"
      />
    </svg>
  );
};

export default GridIcon;
